import { useJustAddedPaymentMethod } from '@/components/billing/useJustAddedPaymentMethod';
import { useUserData } from '@/services/user';

export const useIsMembershipEnded = () => {
    const { membership } = useUserData();
    const [justAddedPaymentMethod] = useJustAddedPaymentMethod();

    // INCOMPLETE means the subscription was created/resumed, but the latest invoice hasn't been paid yet
    // We need to check this here to prevent the user from being immediately redirected away from the /membership-ended page after starting a new membership
    // This is because the membership object will be updated with the new membership, but the status will briefly be INCOMPLETE until the invoice is paid
    return (
        (membership?.isEnded || membership?.status === 'INCOMPLETE') &&
        !justAddedPaymentMethod
    );
};
